import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// cn() — combine class strings and dedup conflicting Tailwind classes.
// Example: cn("p-4", props.className) where className="p-6" → "p-6".
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
